import { Routes } from '@angular/router';
import { adminGuard } from '@core/guards/admin.guard';

import { authGaragesGuard } from '@core/guards/auth-garages.guard';
import { isNotProductionGuard } from '@core/guards/is-not-production.guard';
import { redirectAuthenticatedGuard } from '@core/guards/redirect-authenticated.guard';
import { createTitleResolver } from '@core/resolvers/create-title.resolver';

export const routes: Routes = [
  {
    path: 'auth',
    canMatch: [redirectAuthenticatedGuard],
    loadComponent: () => import('./feature/auth/auth.component').then((m) => m.AuthComponent),
    loadChildren: () => import('./feature/auth/auth.routes').then((m) => m.authRoutes)
  },
  {
    path: 'test',
    canMatch: [isNotProductionGuard],
    loadComponent: () => import('./feature/test/test.component').then((m) => m.TestComponent)
  },
  {
    path: '',
    canMatch: [authGaragesGuard],
    loadComponent: () => import('./core/components/app-layout/app-layout.component').then((m) => m.AppLayoutComponent),
    children: [
      {
        path: 'overview',
        loadComponent: () => import('./feature/overview/overview.component').then((m) => m.OverviewComponent),
        title: createTitleResolver('app.header.overview.title'),
        data: {
          headerKey: 'app.header.overview'
        }
      },
      {
        path: 'vehicles',
        loadChildren: () => import('./feature/vehicles/vehicles.routes').then((m) => m.vehiclesRoutes)
      },
      {
        path: 'logs',
        loadChildren: () => import('./feature/logs/logs.routes').then((m) => m.logsRoutes)
      },
      {
        path: 'parts',
        loadChildren: () => import('./feature/parts/parts.routes').then((m) => m.partsRoutes)
      },
      {
        path: 'vendors',
        loadComponent: () => import('./feature/vendors/vendors.component').then((m) => m.VendorsComponent),
        title: createTitleResolver('app.header.vendors.title'),
        data: {
          headerKey: 'app.header.vendors'
        }
      },
      {
        path: 'admin',
        canMatch: [adminGuard],
        loadComponent: () => import('./feature/admin/admin.component').then((m) => m.AdminComponent),
        title: createTitleResolver('app.header.admin.title'),
        data: {
          headerKey: 'app.header.admin'
        }
      },
      {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
